"use client";

import clsx from "clsx";
import { StepButton } from "../common/StepButton";
import { Card, CardContent } from "../ui/card";
import { Progress } from "../ui/progress";

export interface SetupStep {
  key: string;
  isCompleted: boolean;
  title: string;
  action: () => void;
}

interface SetupCardProps {
  isLoading: boolean;
  steps: SetupStep[];
  completionPercentage: number;
  completionLabel: string;
}

export default function SetupCard({
  isLoading,
  steps,
  completionPercentage,
  completionLabel,
}: Readonly<SetupCardProps>) {
  return (
    <Card className="flex flex-col flex-1">
      <CardContent className={clsx("pt-4", "flex-1", "flex", "flex-col")}>
        <div className={clsx("flex", "flex-col", "gap-4")}>
          {steps.map((step, index) => {
            // Determine step state
            const isCompleted = step.isCompleted;
            // Only the first non-completed step is the next step (can be clicked)
            const isLocked = !isCompleted && !steps.slice(0, index).every(s => s.isCompleted);

            return (
              <StepButton
                key={step.key}
                title={step.title}
                isCompleted={isCompleted}
                isLocked={isLocked}
                isLoading={isLoading}
                onClick={step.action}
                rounded="lg"
              />
            );
          })}
        </div>
        <div
          className={clsx("flex", "items-center", "gap-4", "mt-auto", "pt-6")}
        >
          {isLoading ? (
            <>
              <div
                className={clsx(
                  "animate-pulse",
                  "h-5",
                  "w-24",
                  "bg-500",
                  "rounded"
                )}
              />
              <div
                className={clsx(
                  "animate-pulse",
                  "h-2",
                  "flex-1",
                  "bg-500",
                  "rounded"
                )}
              />
            </>
          ) : (
            <>
              <span
                className={clsx("text-sm", "text-500", "whitespace-nowrap")}
              >
                {completionLabel}
              </span>
              <Progress
                value={completionPercentage}
                size="sm"
                className="flex-1"
              />
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
